import React from "react";
import { Trans, useTranslation } from "react-i18next";
import LegalPage, { Section } from "./LegalPage";

export default function Privacy() {
  const { t } = useTranslation("legal");
  return (
    <LegalPage title={t("privacy.title")} updated="24 July 2026">
      <p className="text-lg text-[#4B4642]">
        {t("privacy.intro")}
      </p>

      <Section heading={t("privacy.collect.heading")}>
        <ul className="list-disc pl-5 space-y-1">
          <li><Trans i18nKey="privacy.collect.account" ns="legal" components={{ b: <span className="font-semibold" /> }} /></li>
          <li><Trans i18nKey="privacy.collect.project" ns="legal" components={{ b: <span className="font-semibold" /> }} /></li>
          <li><Trans i18nKey="privacy.collect.usage" ns="legal" components={{ b: <span className="font-semibold" /> }} /></li>
        </ul>
      </Section>

      <Section heading={t("privacy.use.heading")}>
        <p>{t("privacy.use.body")}</p>
      </Section>

      <Section heading={t("privacy.who.heading")}>
        <p>{t("privacy.who.body")}</p>
      </Section>

      <Section heading={t("privacy.where.heading")}>
        <p>{t("privacy.where.body")}</p>
      </Section>

      <Section heading={t("privacy.rights.heading")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{t("privacy.rights.access")}</li>
          <li>{t("privacy.rights.correction")}</li>
          <li>{t("privacy.rights.deletion")}</li>
          <li>{t("privacy.rights.portability")}</li>
        </ul>
      </Section>

      <Section heading={t("privacy.contact.heading")}>
        <p>
          {t("privacy.contact.bodyPre")}
          <a href="mailto:privacy@orkaiflow.com" className="text-[#E07A5F] font-semibold hover:underline">privacy@orkaiflow.com</a>
          {t("privacy.contact.bodyPost")}
        </p>
      </Section>

      <p className="text-xs text-[#7A7571] italic pt-4">
        {t("shell.starterDisclaimer")}
      </p>
    </LegalPage>
  );
}
